import * as React from 'react';
import { Badge, Col, Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row } from 'reactstrap';
import { Widget } from '../../store/Widget';
import { Link } from "react-router-dom";

type MyProps = { widgetInfo: Widget };
export class WidgetIcon extends React.PureComponent<MyProps> {

    //handleClick = (e: React.MouseEvent<HTMLDivElement>) => {        
    //};

    public render() {
        return (
            <div className="widgetContainer">
                <Link to={"/" + this.props.widgetInfo.widgetInternalName}>
                    <div className="widgetIcon">
                        <img className="widgetImage" src={'./widgetimages/' + this.props.widgetInfo.pictureName}></img>
                        {this.props.widgetInfo.widgetCount >= 0 && <Badge className="widgetBadge" color="danger">{this.props.widgetInfo.widgetCount}</Badge>}
                    </div>
                    <div className="widgetText">
                        {this.props.widgetInfo.widgetTitle}
                    </div>
                </Link>
            </div>
        );
    }
}